import {
	BankAccountList,
	GetGuestBankAccountsParams,
	getGuestBankAccounts,
} from "@/api/bank-accounts";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { bankAccountKeys } from "./keys";

export function bankAccountsQueryOptions(
	params: GetGuestBankAccountsParams,
	options?: QueryOptionsWithoutKeyAndFn<BankAccountList>,
) {
	return queryOptions({
		queryFn: () => getGuestBankAccounts(params),
		queryKey: bankAccountKeys.list(params),
		refetchOnWindowFocus: false,
		...options,
	});
}

export default function useGetBankAccounts(
	params: GetGuestBankAccountsParams,
	options?: QueryOptionsWithoutKeyAndFn<BankAccountList>,
) {
	return useQuery(bankAccountsQueryOptions(params, options));
}
